export default __webpack_public_path__ + "static/log_to_report-a69ab6bf7c069d6c9f94b3eb87af1215.svg";